export default __webpack_public_path__ + "static/media/portfolio-sonnen.9d7fa4b1.png";